import { render, staticRenderFns } from "./EmployeeError.vue?vue&type=template&id=325d2bbb&"
import script from "./EmployeeError.vue?vue&type=script&lang=js&"
export * from "./EmployeeError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports